import actionTypes from '../../actions/actionTypes'
import { fromJS } from 'immutable'
import { returnStateIfNoAction } from '../helpers'
import { PROGRAM_DEFAULT } from '../../constants/state'
import { immutableAddItemToArray } from '../../functions/listsImmutable'

const INIT_STATE = fromJS(PROGRAM_DEFAULT.movieExtensions)

const updateItem = (state, action) => state.setIn(['items', action.payload.pk.toString(), action.payload.extension.toString()], fromJS(action.payload.value))

const addItemToReset = (state, action) => state.set('itemsToReset', immutableAddItemToArray(state.get('itemsToReset'), action.payload.pk.toString()))

const reducers = (state = INIT_STATE, action) => {
    returnStateIfNoAction(action, state)

    switch(action.type){
        case actionTypes.MOVIE_EXTENSIONS_UPDATE_ITEM:
            return updateItem(state, action)
        case actionTypes.MOVIE_EXTENSIONS_ADD_ITEM_TO_RESET:
            return addItemToReset(state, action)
        default:
            return state;
    }
}
export default reducers